__turbopack_context__.v({
  "arrow": "MovementControls-module-scss-module__bRvSgq__arrow",
  "control": "MovementControls-module-scss-module__bRvSgq__control",
  "controls": "MovementControls-module-scss-module__bRvSgq__controls",
});
